import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

type A = (typeof environment)['apps'][number];

@Component({
  selector: 'app-password-reset-finished',
  templateUrl: './password-reset-finished.component.html',
  styleUrls: ['./password-reset-finished.component.css'],
})
export class PasswordResetFinishedComponent implements OnInit {
  constructor(activeRoute: ActivatedRoute) {
    activeRoute.params.subscribe(async (params) => {
      const clientId = params.client_id;
      const redirectUrl = this.getRedirectUrl({
        clientId: clientId,
        appConfig: environment.apps[clientId],
        url: location.href,
      });

      if (!redirectUrl) {
        // 異常系. 設定値を見つけられない場合はリダイレクトしない
        return;
      }
      location.href = redirectUrl;
    });
  }

  getRedirectUrl(params: {
    clientId: string;
    appConfig?: Pick<A, 'appUrl' | 'customUrls'>;
    url: string;
  }) {
    const app = params.appConfig;
    // リダイレクト先のURLを取得suru
    const redirectUrl =
      app?.customUrls?.onUpdatePasswordFinish || // カスタム設定があればそれを使う
      app?.appUrl; // なければ共通のappUrlを使う

    return redirectUrl;
  }

  ngOnInit(): void {}
}
